<div class="header-card-modern">
    <!-- Background Decoration -->
    <div class="header-bg-decoration">
        <div class="circle-decoration circle-1"></div>
        <div class="circle-decoration circle-2"></div>
        <div class="circle-decoration circle-3"></div>
    </div>

    <!-- Main Content -->
    <div class="header-content">

        <!-- Logo Section -->
        <div class="logo-section">
            <div class="logo-wrapper">
                <div class="logo-pulse"></div>
                <i v-if="is_loading" class="pi pi-spin pi-spinner" style="font-size: 4rem"></i>
                <img v-else width="65px" :src="require(`@/assets/logo.png`)" alt="" class="logo-image">

            </div>
        </div>

        <!-- Text Section -->
        <div class="text-section">
            <div class="title-wrapper">
                <h1 class="main-title">
                    <span class="title-gradient">{{ title }}</span>
                </h1>
                <div class="subtitle-wrapper">
                    <span class="subtitle-icon">{{icon}}</span>
                    <span class="subtitle-text">{{ subtitle }}</span>
                </div>
            </div>
        </div>

        <!-- Decorative Line -->
        <div class="header-divider"></div>

        <div class="back-button-wrapper" v-if="clickable">
            <div class="back-button" @click="handleClick">
                <font-awesome-icon :icon="['fas', 'chevron-left']" />
                <span class="back-text">Kembali</span>
            </div>
        </div>
    </div>
</div>